import { createContext } from 'react';

export const DataSchemaContext = createContext<{
  validationSchema: any;
  errorSchema: Record<string, Record<string, string>>;
  /**
   * Runtime overrides for the validation schema.
   * Example:
   * {
   *   properties: {
   *     fieldName: {
   *       minLength: 12,
   *       maxLength: 30
   *       ...
   *     }
   *   }
   * }
   */
  overrideValidationSchema: (override: Record<string, any>) => void;
  /**
   * Runtime override for the error schema.
   * Example:
   * {
   *   errorSchema: {
   *     fieldName: {
   *       minLength: "must not be less than 12 characters",
   *       maxLength: "must not be more than 30 characters"
   *       ...
   *     }
   *   }
   * }
   */
  overrideErrorSchema: (override: Record<string, any>) => void;
}>({
  validationSchema: {},
  errorSchema: {},
  overrideValidationSchema: () => {},
  overrideErrorSchema: () => {},
});

export default DataSchemaContext;
